module.exports = __webpack_public_path__ + "static/media/HatterLogo.687e49cf.svg";